module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/图片5.5dea4952.png";